import { SuccessPlaceholder } from '@components'
import { ArrowLeftCircleIcon, DocumentDuplicateIcon } from '@heroicons/react/24/outline'
import { Button } from '@heroui/react'
import PropTypes from 'prop-types'

const EmailUpdateSuccess = ({ handleClick, handleCopyToClipboard, email }) => (
  <SuccessPlaceholder 
    title="Email Updated"
    message="This account has been updated. You can now login with the email below."
  >
    <div className='flex flex-col justify-center py-4 mt-8 rounded-lg bg-content2 w-100'>
      <div className="flex items-center justify-center gap-3">
        <p className='text-2xl font-bold'>{email}</p>

        <Button onPress={() => handleCopyToClipboard(email)} isIconOnly>
          <DocumentDuplicateIcon className="p-1 text-white bg-gray-400 h-14 w-14" />
        </Button>
      </div>
    </div>

    <Button color="secondary" className="mt-6 font-semibold" size="lg" fullWidth onPress={() => handleClick()}>
      <ArrowLeftCircleIcon className='w-8 h-8' /> Back to account details
    </Button>
  </SuccessPlaceholder>
)

EmailUpdateSuccess.propTypes = {
  handleClick: PropTypes.func.isRequired,
  handleCopyToClipboard: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired
}

export default EmailUpdateSuccess